import React from 'react';

import './style.scss';

import HeaderLink from './HeaderLink/HeaderLink';

/** Header links component. */
const HeaderLinks: React.FC = () => {
  return (
    <div className="navbar-collapse collapse" id="navbar">
      <ul className="nav navbar-nav">
        <HeaderLink href="https://www.core-mark.com/about/" text="About" icon="/assets/img/svg/ic-about.svg" />
        <HeaderLink href="http://ir.core-mark.com/" text="Investors" icon="/assets/img/svg/ic-investors.svg" />
        <HeaderLink href="https://careers.core-mark.com/" text="Careers" icon="/assets/img/svg/ic-careers.svg" />
        <HeaderLink
          href="https://www.core-mark.com/distribution-centers/"
          text="Contact"
          icon="/assets/img/svg/ic-contact.svg"
        />
        <HeaderLink
          href="https://www.core-mark.com/retailer-programs/"
          text="Retailer Programs"
          icon="/assets/img/svg/ic-programs.svg"
        />
        <HeaderLink
          href="https://www.core-mark.com/retailer-solutions/"
          text="Retailer Solutions"
          icon="/assets/img/svg/ic-solutions.svg"
        />
      </ul>
    </div>
  );
};

export default HeaderLinks;
